import React from "react";
import {FormattedMessage} from 'react-intl';
import {ApiResponse} from "./axios";
import {flagType, Package} from "./package";
import {PaymentGateway} from "./paymentGateway";
import __i18n from "../intl/__i18n";


export interface Subscription extends ApiResponse {
  title: string;
  description: string;
  duration: string;
  flag: flagType;
  price: string;
  explicit_discount: number;
  icon_path: string;
  is_active: true;
  id: string;
  short_id: string;
}


export const enum SubscriptionStatus {
    "None" = "none",
    "Pending" = "pending",
    "Active" = "active",
    "Unsubscribe" = "unsubscribe",
    "Failed" = "failed",
}

export const SubscriptionStatusOptions = [{
    value: SubscriptionStatus.Pending,
    label: <FormattedMessage id="app.pending" defaultMessage={`Pending`}/>
}, {
    value: SubscriptionStatus.Active,
    label: <FormattedMessage id="app.active" defaultMessage={`Active`}/>
}, {
    value: SubscriptionStatus.Unsubscribe,
    label: <FormattedMessage id="app.unsubscribe" defaultMessage={`Unsubscribe`}/>
},{
    value: SubscriptionStatus.Failed,
    label: <FormattedMessage id="app.failed" defaultMessage={`Failed`}/>
}];



export const enum SubscriptionFlag {
  "None" = "none",
  "CreateByPaymentNotification" = "create_by_payment_notification",
  "CreateByUnsubscriptionNotification" = "create_by_unsubscription_notification",
  "CreateBySubscriptionNotification" = "create_by_subscription_notification",
  "CreatedByCronJob" = "created_by_cron_job",
  "AbleToUnsubscribe" = "able_to_unsubscribe",
  "CreateByAffiliate" = "create_by_affiliate",
  "CreateByAdministrator" = "create_by_administrator",
  "TrafficFree" = "traffic_free",
}

export const SubscriptionFlagOptions = [{
  value: SubscriptionFlag.CreateByPaymentNotification,
  label: <FormattedMessage id="app.create_by_payment_notification" defaultMessage={`Create By Payment Notification`}/>
}, {
  value: SubscriptionFlag.CreateByUnsubscriptionNotification,
  label: <FormattedMessage id="app.create_by_unsubscription_notification" defaultMessage={`Create By Unsubscription Notification`}/>
}, {
  value: SubscriptionFlag.CreateBySubscriptionNotification,
  label: <FormattedMessage id="app.create_by_subscription_notification" defaultMessage={`Create By Subscription Notification`}/>
},{
  value: SubscriptionFlag.CreatedByCronJob,
  label: <FormattedMessage id="app.created_by_cron_job" defaultMessage={`Created By Cron Job`}/>
},{
  value: SubscriptionFlag.AbleToUnsubscribe,
  label: <FormattedMessage id="app.able_to_unsubscribe" defaultMessage={`Able To Unsubscribe`}/>
},{
  value: SubscriptionFlag.CreateByAffiliate,
  label: <FormattedMessage id="app.create_by_affiliate" defaultMessage={`Create By Affiliate`}/>
},{
  value: SubscriptionFlag.CreateByAdministrator,
  label: <FormattedMessage id="app.create_by_administrator" defaultMessage={`Create By Administrator`}/>
},{
  value: SubscriptionFlag.TrafficFree,
  label: __i18n("Traffic Free")
}];



export interface Subscription extends ApiResponse {
  user_identifier: number;
  package: Package[];
  start_time: string;
  end_time: string;
  unsubscribed_at: string;
  status: SubscriptionStatus;
  flag: SubscriptionFlag;
  price: number;
  effective_price: number;
  used_internal_balance_amount: number;
  client_reference_id: string;
  payment_gateway: PaymentGateway;
  id: string;
  short_id: string;
  created_at: string;
  "modified_at": string
}

